import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import ModalComponent from '../../layout/Modals/ModalComponent/ModalComponent';
import { GenericErrorModal } from '../AlertDetailsPage/AlertDetailsModals/GenericErrorModal/GenericErrorModal';
import { connectModalContainerContextToComponent } from '../../../contexts/ModalContext/ModalContext';
import { deleteComment } from '../../../redux/slices/conversation/conversationSlice';

const DeleteCommentModal = (props) => {
  const {
    setModalJSX,
    commentId,
    handleDeleteSuccess,
  } = props;
  const dispatch = useDispatch();
  const [deleteCommentButtonText, setDeleteCommentButtonText] = useState('Delete Comment');
  const [deleteCommentSubmitting, setDeleteCommentSubmitting] = useState(false);
  const [show, setShow] = useState(true);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const onConfirmDeleteComment = async () => {
    setDeleteCommentButtonText('Deleting Comment...');
    setDeleteCommentSubmitting(true);
    try {
      await dispatch(deleteComment({ id: commentId })).unwrap();
      handleDeleteSuccess(commentId);
    } catch (error) {
      setModalJSX(
        <GenericErrorModal
          show={show}
          message={error.message}
        />,
      );
    }
    setDeleteCommentSubmitting(false);
    closeModalHandler();
  };

  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction
      confirmButtonAction={onConfirmDeleteComment}
      confirmButtonText={deleteCommentButtonText}
      isBtnDisabled={deleteCommentSubmitting}
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete Comment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>are you sure you want to delete this comment?</p>
      </Modal.Body>
    </ModalComponent>
  );
};

DeleteCommentModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  handleDeleteSuccess: PropTypes.func.isRequired,
  commentId: PropTypes.number.isRequired,
};

export default connectModalContainerContextToComponent(DeleteCommentModal);
